import { render, staticRenderFns } from "./SingleChoiceV1Properties.vue?vue&type=template&id=e9dd693c&"
import script from "./SingleChoiceV1Properties.vue?vue&type=script&lang=js&"
export * from "./SingleChoiceV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports